import styled from 'styled-components'

export default styled.div`
  background: #393838;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`



// WEBPACK FOOTER //
// ./src/components/templates/MainLayout/SidebarInner.js